import { render, staticRenderFns } from "./MemberNode.vue?vue&type=template&id=30401016&scoped=true"
import script from "./MemberNode.vue?vue&type=script&lang=ts"
export * from "./MemberNode.vue?vue&type=script&lang=ts"
import style0 from "./MemberNode.vue?vue&type=style&index=0&id=30401016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30401016",
  null
  
)

export default component.exports